// vim: set ts=2 sts=2 sw=2 et:

// Sponsors cargados en la web (wrpf.com.ar/sponsors). En el lab se enlazan directo; en producción deberían
// llegar con el bundle del torneo para que el overlay no dependa de una lista fija.

import type { WrpfSponsor } from "../handoff/types";

// Mismo formato que los sponsors del bundle.
export type LabSponsor = WrpfSponsor;

const STORAGE = "https://hroodutxesuleyerwaiw.supabase.co/storage/v1/object/public/default/sponsors/";

export const LAB_SPONSORS: ReadonlyArray<LabSponsor> = [
  { name: "dots", logoUrl: `${STORAGE}6125ea3c-4d9a-4711-9464-e5ab803a5786.png` },
  { name: "Masajes deportivos", logoUrl: `${STORAGE}7e266c43-14b9-46ae-be6b-787b016ac065.png` },
  { name: "Powercore Suplementos", logoUrl: `${STORAGE}cfcae085-c91a-422d-b50e-aa933dad3fbd.png` },
  { name: "EGOS Fit", logoUrl: `${STORAGE}30ff5e91-e68c-421b-ad81-700f5d892aa7.png` },
  { name: "AL VARO", logoUrl: `${STORAGE}d1f6d3f5-b18b-42e9-9f40-6a154d9062c5.jpeg` },
  { name: "Full Power", logoUrl: `${STORAGE}b19b12ab-a0ee-468d-9486-2024dd904c39.png` },
  { name: "PowerLife GYM", logoUrl: `${STORAGE}66dd7cf4-b941-447e-9f7f-8dc38632f428.png` },
  { name: "Gimnasio Jones", logoUrl: `${STORAGE}f3dee64d-bace-4873-a83a-9e36c666a753.png` },
  { name: "M&G Proteinbar", logoUrl: `${STORAGE}24a5fc00-0a49-4055-9f97-e4c8c232e3ca.png` },
  { name: "Euriale Personalizados", logoUrl: `${STORAGE}035d2f49-3b0e-4658-ad60-0ea8adcf2e73.png` },
  { name: "MCJ Equipment", logoUrl: `${STORAGE}066acbc2-6bca-4470-ac21-905132691dac.png` },
  { name: "Magro", logoUrl: `${STORAGE}196d9d62-c0be-4156-b4b5-73a2034f9f9f.png` },
  { name: "Tauros GYM", logoUrl: `${STORAGE}5c9ca34b-d6d1-4afa-8876-82265ac7f80f.png` },
];
